import React, { useState } from 'react';
import Modal from 'react-modal';
import toast, { Toaster } from 'react-hot-toast';
import { motion, AnimatePresence } from "framer-motion";
import { CAREERS } from '../API/Config';

Modal.setAppElement('#root'); // Important for accessibility

const jobDetails = [
  {
  title: 'Business Development Manager (BDM)',
  location: 'Madurai',
  salary: 'Negotiable',
  requirements: [
    '3 to 5 years of experience in business development or sales',
    'Strong communication, presentation, and negotiation skills',
    'Ability to identify new business opportunities and build long-term client relationships',
    'Experience in lead generation, market research, and client acquisition',
    'Understanding of IT services or software solutions is an added advantage',
  ],
},
  {
    title: 'FRONTEND DEVELOPER',
    location: 'Madurai',
    salary: 'Negotiable',
    requirements: [
      'Strong knowledge in HTML, CSS, JavaScript',
      'Experience with React or Angular',
      'Ability to build responsive UIs',
      'Understanding of RESTful APIs',
    ],
  },
  {
    title: 'BACKEND DEVELOPER',
    location: 'Madurai',
    salary: 'Negotiable',
    requirements: [
      'Experience with Node.js / Express',
      'Database knowledge (MongoDB, MySQL)',
      'API development & authentication',
      'Troubleshooting and debugging skills',
    ],
  },
  {
    title: 'FULL STACK DEVELOPER',
    location: 'Madurai',
    salary: 'Negotiable',
    requirements: [
      'Good logical thinking',
      'Smart problem solving',
      'Quick learning',
      'Interested to work in international projects',
      '1-3 years experience in JS, React, Node, API creation',
    ],
  },
  {
    title: 'TESTING / AUTOMATION',
    location: 'Madurai',
    salary: 'Negotiable',
    requirements: [
      'Manual and Automation Testing',
      'Writing test cases and plans',
      'Bug tracking and reporting',
    ],
  },
  
];

const CareersFormSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeJob = jobDetails[activeIndex];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    experience: '',
    currentCTC: '',
    expectedCTC: '',
    resume: null,
    discovery: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Validate file type and size
    if (formData.resume) {
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(formData.resume.type)) {
        toast.error('Please upload a PDF, DOC, or DOCX file.');
        setIsSubmitting(false);
        return;
      }
      if (formData.resume.size > 5 * 1024 * 1024) { // 5MB limit
        toast.error('Resume file size must be under 5MB.');
        setIsSubmitting(false);
        return;
      }
    }

    // Validate phone number
    const phoneRegex = /^\+?[1-9]\d{1,14}$/;
    if (!phoneRegex.test(formData.phone)) {
      toast.error('Please enter a valid phone number.');
      setIsSubmitting(false);
      return;
    }

    // Create FormData for API request
    const formDataToSend = new FormData();
    formDataToSend.append('fullname', formData.fullName);
    formDataToSend.append('phonenumber', formData.phone);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('experience', formData.experience);
    if (parseInt(formData.experience) > 0) {
      formDataToSend.append('currentctc', formData.currentCTC);
      formDataToSend.append('expectedctc', formData.expectedCTC);
    }
    formDataToSend.append('howdidyouhearaboutus', formData.discovery);
    if (formData.resume) {
      formDataToSend.append('resume', formData.resume);
    }
    formDataToSend.append('jobTitle', activeJob.title); // Include job title for context

    // Show loading toast
    const toastId = toast.loading('Submitting application...');

    try {
      const response = await fetch(CAREERS, {
        method: 'POST',
        body: formDataToSend,
      });

      const result = await response.json();

      if (response.ok) {
        toast.success('Application submitted successfully!', { id: toastId });
        setFormData({
          fullName: '',
          phone: '',
          email: '',
          experience: '',
          currentCTC: '',
          expectedCTC: '',
          resume: null,
          discovery: '',
        });
        setIsModalOpen(false);
      } else {
        toast.error(result.message || 'Failed to submit application.', { id: toastId });
      }
    } catch (err) {
      toast.error('Error submitting application. Please try again later.', { id: toastId });
      console.error('API Error:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 px-6 bg-white text-black">
      <div id='ApplyNow' className="px-5">
        <h2 className="text-4xl md:text-6xl font-semibold mb-6">We're Always Hiring</h2>
        <p className="text-lg font-normal leading-relaxed mb-6">
          Vivekasoftek is always hiring smart & bright developers...
        </p>

        <ul className="ml-6 mb-10 space-y-2">
          <li className="font-medium">- Quick & Self learners</li>
          <li className="font-medium">- Always interested to learn new technology</li>
          <li className="font-medium">- Ready to work in challenging international projects</li>
          <li className="font-medium">- Ready to investigate/troubleshoot problems</li>
          <li className="font-medium">- Team Player</li>
        </ul>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Left: Job Tabs */}
        <div className="bg-gray-100 rounded p-4 shadow-sm">
          {jobDetails.map((job, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`w-full text-left px-4 py-3 rounded mb-2 font-semibold transition-all ${
                activeIndex === index ? 'bg-black text-white' : 'bg-white text-black hover:bg-gray-200'
              }`}
            >
              {job.title.toUpperCase()}
            </button>
          ))}
        </div>

        {/* Right: Job Details */}
        <div className="col-span-2 bg-white rounded p-6 shadow-md border">
  <div className="flex items-center justify-between mb-4">
    <h2 className="text-2xl border-b-2 border-gray-300 font-bold">{activeJob.title}</h2>
    <div className="flex justify-end">
      <button
        onClick={() => setIsModalOpen(true)}
        className="bg-black border-2 border-black text-white hover:bg-transparent hover:text-black font-medium px-4 py-2 rounded-full"
      >
        APPLY NOW
      </button>
    </div>
  </div>

  <AnimatePresence mode="wait">
    <motion.div
      key={activeIndex} // important for triggering animation when index changes
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.3 }}
    >

    <div className='border-2 rounded p-3'>

      <p className="mb-2 text-sm flex justify-between items-center">
        <span className="font-normal">
          <span className="font-medium">Salary:</span> {activeJob.salary}
        </span>
        <span className="font-normal">
          <span className="font-medium">Location of Job:</span> {activeJob.location}
        </span>
      </p>

      <div className="mt-4">
        <h3 className="text-lg font-medium mb-2">Requirements:</h3>
        <ul className="space-y-1">
          {activeJob.requirements.map((req, i) => (
            <li key={i} className="font-normal before:content-['-'] before:mr-2">
              {req}
            </li>
          ))}
        </ul>
      </div>

      </div>


    </motion.div>
  </AnimatePresence>
</div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        className="bg-white p-6 max-w-3xl w-full mx-4 md:mx-auto mt-20 rounded shadow-lg outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start z-50"
      >
        <h2 className="text-xl font-semibold mb-4">Apply for {activeJob.title}</h2>

        <div className="max-h-[65vh] overflow-y-auto pr-2">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block font-medium mb-1">Full Name</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  className="w-full font-medium border p-2 rounded"
                  required
                />
              </div>

              <div>
                <label className="block font-medium mb-1">Phone Number</label>
                <input
                  type="number"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full font-medium border p-2 rounded"
                  required
                />
              </div>

              <div>
                <label className="block font-medium mb-1">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full font-medium border p-2 rounded"
                  required
                />
              </div>

              <div>
                <label className="block font-medium mb-1">Experience</label>
                <select
                  name="experience"
                  value={formData.experience}
                  onChange={handleChange}
                  className="w-full font-medium border p-2 rounded text-sm font-light"
                  required
                >
                  <option className="text-sm font-light" value="">Experience in this position</option>
                  <option className="text-sm font-light" value="0">Fresher (0 years)</option>
                  <option className="text-sm font-light" value="1">1 Year</option>
                  <option className="text-sm font-light" value="2">2 Years</option>
                  <option className="text-sm font-light" value="3">3 Years</option>
                  <option className="text-sm font-light" value="4">4+ Years</option>
                </select>
              </div>

              {parseInt(formData.experience) > 0 && (
                <>
                  <div>
                    <label className="block font-medium mb-1">Current CTC</label>
                    <input
                      type="text"
                      name="currentCTC"
                      value={formData.currentCTC}
                      onChange={handleChange}
                      className="w-full font-medium border p-2 rounded"
                    />
                  </div>
                  <div>
                    <label className="block font-medium mb-1">Expected CTC</label>
                    <input
                      type="text"
                      name="expectedCTC"
                      value={formData.expectedCTC}
                      onChange={handleChange}
                      className="w-full font-medium border p-2 rounded"
                    />
                  </div>
                </>
              )}

              <div className="md:col-span-2">
                <label className="block font-medium mb-1">Upload Resume</label>
                <input
                  type="file"
                  name="resume"
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                  className="w-full font-medium border p-2 rounded font-light text-sm"
                  required
                />
              </div>

              <div className="md:col-span-2">
                <label className="block font-medium mb-1">How did you hear about us?</label>
                <textarea
                  name="discovery"
                  value={formData.discovery}
                  onChange={handleChange}
                  placeholder="e.g., LinkedIn, Friend, Website"
                  className="w-full font-medium border p-2 rounded text-sm"
                  rows={3}
                  maxLength={200}
                />
              </div>
            </div>

            <div className="flex justify-end gap-3 pt-4">
              <button
                type="button"
                className="bg-gray-300 text-black px-4 py-2 rounded text-sm font-normal"
                onClick={() => setIsModalOpen(false)}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="bg-black text-white px-4 py-2 rounded text-sm font-normal flex items-center"
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <svg
                    className="animate-spin h-5 w-5 mr-2"
                    viewBox="0 0 24 24"
                  >
                    <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="4" fill="none" />
                  </svg>
                )}
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </section>
  );
};

export default CareersFormSection;